import { render, staticRenderFns } from "./appSwitch.vue?vue&type=template&id=6c817094"
import script from "./appSwitch.vue?vue&type=script&lang=js"
export * from "./appSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports